import { useState } from "react";
import { cn } from "@/lib/utils";

interface LazyImageProps {
  src: string;
  alt: string;
  className?: string;
  wrapperClassName?: string;
}

export function LazyImage({
  src,
  alt,
  className,
  wrapperClassName,
}: LazyImageProps) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  return (
    <span className={cn("block overflow-hidden relative", wrapperClassName)}>
      {/* Shimmer skeleton while loading */}
      {!loaded && !error && (
        <div className="w-full aspect-[4/5] rounded-xl skeleton-card bg-gradient-to-b from-[#F8F8FF] to-[#EFEFFF]" />
      )}
      {error ? (
        <div className="w-full aspect-[4/5] rounded-xl bg-gradient-to-b from-[#F8F8FF] to-[#EFEFFF] flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-muted-foreground/40"><rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></svg>
        </div>
      ) : (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
          className={cn(
            className,
            "transition-opacity duration-300 ease-out",
            loaded ? "opacity-100" : "opacity-0 absolute inset-0"
          )}
        />
      )}
    </span>
  );
}
